export default __webpack_public_path__ + "static/media/lease_single_visited.568086bd.svg";